(function () {
  'use strict';

  function initAboutTeardown(root) {
    if (!root || root.getAttribute('data-about-ready') === 'true') return;
    root.setAttribute('data-about-ready', 'true');

    setupLayers(root);
    setupStages(root);
    setupArtists(root);
    setupTrey(root);
    setupSeasonsEgg(root);
  }

  /* The door to the hidden timeline page.
     The seasons row renders newest-first, so clicking the year cards in
     CHRONOLOGICAL order is a deliberate act rather than something you do by
     accident. Get the sequence right and a link appears; get it wrong and the
     progress resets with no feedback, which is the point of an easter egg.
     Does nothing at all unless the section has a timeline URL configured. */
  function setupSeasonsEgg(root) {
    var egg = root.querySelector('[data-about-egg]');
    var cards = Array.from(root.querySelectorAll('[data-about-yr]'));
    if (!egg || cards.length < 2) return;

    var sequence = cards
      .map(function (card) {
        return card.getAttribute('data-about-yr');
      })
      .sort();

    var progress = 0;

    cards.forEach(function (card) {
      /* Reachable by keyboard too — the egg should not be mouse-only. */
      card.setAttribute('tabindex', '0');

      var advance = function () {
        if (card.getAttribute('data-about-yr') === sequence[progress]) {
          progress += 1;
        } else {
          /* Restart, but count this click if it was itself a valid opening. */
          progress = card.getAttribute('data-about-yr') === sequence[0] ? 1 : 0;
        }

        if (progress < sequence.length) return;

        progress = 0;
        egg.hidden = false;
        egg.removeAttribute('tabindex');
        egg.classList.add('is-found');
        egg.focus();
      };

      card.addEventListener('click', advance);
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          advance();
        }
      });
    });
  }

  function setupLayers(root) {
    var layers = Array.from(root.querySelectorAll('[data-about-layer]'));
    if (!layers.length) return;

    function activate(index) {
      layers.forEach(function (layer, i) {
        var on = i === index;
        layer.classList.toggle('is-active', on);
        layer.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    layers.forEach(function (layer, i) {
      layer.addEventListener('mouseenter', function () {
        activate(i);
      });
      layer.addEventListener('focus', function () {
        activate(i);
      });
      layer.addEventListener('click', function () {
        activate(i);
      });
    });

    activate(1);
  }

  function setupStages(root) {
    var stages = Array.from(root.querySelectorAll('[data-about-stage]'));
    if (!stages.length) return;

    function activate(index) {
      stages.forEach(function (stage, i) {
        var on = i === index;
        stage.classList.toggle('is-active', on);
        stage.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    stages.forEach(function (stage, i) {
      stage.addEventListener('mouseenter', function () {
        activate(i);
      });
      stage.addEventListener('focus', function () {
        activate(i);
      });
      stage.addEventListener('click', function () {
        activate(i);
      });
    });

    activate(3);
  }

  function setupArtists(root) {
    var names = Array.from(root.querySelectorAll('[data-about-artist-name]'));
    var notes = Array.from(root.querySelectorAll('[data-about-artist-note]'));
    // One frame per artist inside every stage tile, in artist order, so a
    // frame's artist is its index modulo the artist count.
    var stageFrames = Array.from(root.querySelectorAll('[data-about-artist-stage]'));
    if (!names.length) return;

    var prev = root.querySelector('[data-about-artist-prev]');
    var next = root.querySelector('[data-about-artist-next]');
    var current = 0;

    function show(index) {
      current = (index + names.length) % names.length;
      names.forEach(function (artist, i) {
        var on = i === current;
        artist.classList.toggle('is-active', on);
        artist.hidden = !on;
      });
      notes.forEach(function (note, i) {
        var on = i === current;
        note.classList.toggle('is-active', on);
        note.hidden = !on;
      });
      stageFrames.forEach(function (frame, i) {
        frame.hidden = i % names.length !== current;
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(current - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        show(current + 1);
      });
    }

    show(0);
  }

  function setupTrey(root) {
    var more = root.querySelector('[data-about-trey-more]');
    var extras = Array.from(root.querySelectorAll('[data-about-trey-extra]'));
    if (!more || !extras.length) return;

    more.addEventListener('click', function () {
      extras.forEach(function (node) {
        node.hidden = false;
      });
      more.hidden = true;
    });
  }

  function boot() {
    document.querySelectorAll('[data-about-teardown]').forEach(initAboutTeardown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-about-teardown]')
      : null;
    if (root) {
      root.removeAttribute('data-about-ready');
      initAboutTeardown(root);
    }
  });
})();
